export const END_POINTS = {
  REGISTER: "/api/auth/register",
  LOGIN: "/api/auth/login",
  FORGOT_PASSWORD: "/api/auth/forgot-password",
  LOGOUT: "/api/auth/logout",
  VERIFY_RESET_PASSWORD: "api/auth/verify-password-reset",
  RESEND_CODE: "api/auth/resend-password-reset",
  RESET_PASSWORD: "api/auth/reset-password",
  GET_PROFILE: "api/user/profile",
  EDIT_PROFILE: "api/user/profile",
  CHANGE_PASSWORD: "api/auth/change-password",

  /** upload images and videos */
  UPLOAD_SINGLE_FILE: "api/upload/single",
  UPLOAD_MULTIPLE_FILE: "api/upload/multiple",
  UPLOAD_SINGLE_VIDEO: "api/upload/single-video",

  /** Saved places */
  GET_ALL_SAVED_PLACES: "api/saved-items/",
  UN_SAVED_PLACES: "api/saved-places",
  SAVED_PLACES: "api/saved-places/",

  /** My Places */
  ADD_PLACE: "api/place/",
  GET_MY_PLACES: "api/place/",
  GET_PLACE_DETAILS: "api/place/details/",
  EDIT_PLACE_DETAILS: "api/place/",
  GET_PLACE_DETAILS_BY_STATUS: "api/place/my?status=",

  /** Content */
  GET_CONTENT: "api/content/places-deals",

  /** Deals Api */
  ADD_DEALS: "api/deal",
  EDIT_DEALS: "api/deal/",

  /**Commercial apis */
  ADD_COMMERCIAL: "api/commercial",
  GET_ALL_COMMERCIAL: "api/commercial/my",
  USER_ALL_COMMERCIAL: "api/commercial/public",
  GET_POPULAR_COMMERCIAL: "api/commercial/public/popular",
  Get_Near_Commercial: "api/commercial/public/near",
  /** Events apis */
  ADD_EVENTS: "api/event",
  EDIT_EVENTS: "api/event",
  GET_MY_EVENTS:"api/event/my",
  GET_ALL_EVENTS:"api/content/events",

  /** Places stats */
  PLACES_STAS: "api/place/",

  /**Payment api */
  CREATE_INTENT: "api/payment/create-intent",
  WEBHOOK: "api/payment/webhook",

  // reviews api
  REVIEWS: "api/review",
};
